/**
 * Dropdown Disclosure component.
 */
(() => {
  if (customElements.get('dropdown-input')) {
    return;
  }

  class DropdownDisclosure extends HTMLElement {
    /**
     * Constructor.
     */
    constructor() {
      super();
    }
  
    /**
     * Connected callback.
     */
    connectedCallback() {
      this.summary = this.querySelector('summary');
      this.details = this.querySelector('details');
      this.buttons = this.querySelectorAll('button');
      this.select = this.querySelector('select');
      this.init();
    }
  
    /**
     * Initialize.
     */
    init() {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
      if (!this.buttons || !this.select) {
        return;
      }
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
  
    /**
     * Handle button click.
     *
     * @param {Event} event
     */
    onButtonClick(event) {
      const currentTarget = event.currentTarget;
      const value = currentTarget.dataset.value;
  
      currentTarget.parentElement.parentElement
        .querySelector('.is-active')
        .classList.remove('is-active');
      currentTarget.parentElement.classList.add('is-active');
  
      this.querySelector('[data-label]').innerHTML = currentTarget.innerHTML;
  
      this.select.value = value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.close(event, this.summary, this.details);
    }
  
    /**
     * Handle summary click.
     *
     * @param {Event} event
     */
    onSummaryClick(event) {
      const summaryElement = this.summary || event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
  
      isOpen
        ? this.close(event, summaryElement, detailsElement)
        : this.open(summaryElement, detailsElement);
    }
  
    /**
     * Handle document click.
     *
     * @param {Event} event
     */
    onDocumentClick(event) {
      if (
        !this.details.contains(event.target) &&
        this.details.hasAttribute('open')
      )
        this.close(event, this.summary, this.details);
    }
  
    /**
     * Open.
     *
     * @param {HTMLElement} summaryElement
     * @param {HTMLElement} detailsElement
     */
    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(detailsElement, summaryElement);
    }
  
    /**
     * Close.
     *
     * @param {Event} event
     * @param {HTMLElement} summaryElement
     * @param {HTMLElement} detailsElement
     * @returns {Void}
     */
    close(event, summaryElement, detailsElement) {
      if (event === undefined) return;
      const eventTarget = event.target;
      const originatedFromSummary =
        eventTarget === summaryElement || summaryElement.contains(eventTarget);
      if (originatedFromSummary) {
        event.preventDefault();
      }
  
      detailsElement.classList.remove('is-open');
      removeTrapFocus(summaryElement);
      this.closeAnimation(detailsElement);
    }
  
    /**
     * Close animation.
     *
     * @param {HTMLElement} detailsElement
     */
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        elapsedTime < 400
          ? window.requestAnimationFrame(handleAnimation)
          : detailsElement.removeAttribute('open');
      };
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('dropdown-input', DropdownDisclosure);
})();
